module.exports = __webpack_public_path__ + "img/stakebody_driving.ea82db1e.svg";